module.exports = __webpack_public_path__ + "static/media/loaded_pass.2f3d1c34.svg";